import { format as dateFnsFormat, parse } from "date-fns";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { FaPenNib } from "react-icons/fa6";
import { confirmDialog } from "primereact/confirmdialog";
import { useContext } from "react";
import UiContext from "../../store/ui-context";
import { bg } from "date-fns/locale";

const SignatureBox = (props) => {
  const {
    label,
    title,
    fieldId,
    verifField,
    fieldData,
    fieldDatetime,
    data,
    onConfirm,
    jabatanId,
    jabatanIdRequirement,
    onValidate,
    disabled,
    bgColor,
    color,
  } = props;

  const name = data && data[fieldData] ? data[fieldData].nama : undefined;
  const image = data && data[fieldData] ? data[fieldData].signature : undefined;
  const date =
    data && data[fieldDatetime] ? new Date(data[fieldDatetime]) : undefined;

  const uiContext = useContext(UiContext);

  const handleClickValidToVerify = () => {
    const accept = () => {
      if (onConfirm) onConfirm();
    };

    const reject = () => { };

    confirmDialog({
      message: `Meng-verifikasi sebagai ${label.toUpperCase()}, lanjutkan ?`,
      header: "Konfirmasi Verifikasi",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Konfirmasi",
      rejectLabel: "Tidak",
      accept,
      reject,
    });
  };

  const handleClickInvalidToVerify = () => {
    uiContext.showVerifAuthDialog({
      verifField: verifField,
      onConfirm: onConfirm,
    });
    // uiContext.showErrorMsg(
    //   "Error",
    //   "Anda tidak berhak untuk verifikasi disini!"
    // );
  };

  const handleClickVerify = async () => {
    let isValid = true;

    if (onValidate) {
      isValid = await onValidate();
    }
    if (isValid) {
      if (jabatanIdRequirement.includes(jabatanId)) {
        handleClickValidToVerify();
      } else {
        handleClickInvalidToVerify();
      }
    }
  };

  // check if windows size is lg
  const isLg = window.innerWidth < 1024 ? false : true;

  return (
    <div className="!py-2 col-center-center w-[5rem] lg:w-[10rem] gap-1 ">
      <div className="col-center-center">
        <span className="text-xs uppercase font-bold text-zinc-400 space-x-2 text-center">
          {label}
        </span>
        <span className="text-center text-xs italic text-zinc-400 space-x-2">
          {date ? dateFnsFormat(date, "dd/MM/yyyy HH:mm") : "-"}
        </span>
      </div>
      <div
        className={`col-center-center w-100 h-100 border-2 border-slate-400 rounded-md min-h-[2rem] lg:min-h-[5rem] ${bgColor ?? ""
          }`}
      >
        {data && data[fieldData] && (
          <div className="col-center-center min-w-[7.2rem] min-h-[3.2rem] lg:min-h-[4.2rem] max-w-[7.2rem] max-h-[3.2rem] lg:max-h-[4.2rem] ">
            {/* <Image
              className=""
              alt={`signature-${label}`}
              width="100"
              src={image}
            /> */}
            <div className="col-center-center w-full h-full text-green-600">
              <i className="pi pi-check-circle" style={{ fontSize: "20px" }} />
              <span className={`mt-1 rounded-full text-sm font-semibold text-green-700`}>
                VERIFIED
              </span>
            </div>
          </div>
        )}
        {(!data || !data[fieldData]) && (
          <Button
            className={`min-h-[3.3rem] ${color ? color + " border-none" : ""} `}
            disabled={disabled}
            onClick={handleClickVerify}
          >
            <div className="row-center-center gap-2 min-w-[3.2rem]">
              <FaPenNib size={20} />
              {isLg && (
                <div className="col-center-center leading-tight">
                  <span className="!text-sm">VERIFY</span>
                  {/* <span className="!text-xs">Tangan</span> */}
                </div>
              )}
            </div>
          </Button>
        )}
      </div>
      <div className="col-center-center">
        <span className="space-x-2 font-semibold text-zinc-600 text-center text-sm leading-tight">
          {name ? name : "-"}
        </span>
        <span className="text-xs uppercase font-bold text-zinc-400 space-x-2 text-center">
          {title ? title : "-"}
        </span>
      </div>
    </div>
  );
};

export default SignatureBox;
